<ion-button
  fill="clear"
  size="small"
  [color]="buttonColor"
  [ngClass]="classes"
  (click)="openCancellationPolicy()"
>
  <ion-label class="link"> Cancellation Policy </ion-label>
</ion-button>
